import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { useState } from "react";
import SyntaxHighlighter from "react-syntax-highlighter";
import useColors from "../../../../api/hooks/useColors";

const SqlCommandDisplay = ({ sqlCommand, isSql }) => {
  const colors = useColors();
  const [expanded, setExpanded] = useState(false);

  return (
    <Accordion
      expanded={expanded}
      onChange={() => setExpanded((prev) => !prev)}
      sx={{
        backgroundColor: `${colors.sidebar_bg}`,
        width: "700px",
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle2" color={colors.primary_darker}>
          View SQL Command
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            display: "flex",
            padding: "0",
            margin: "0",
            flexDirection: "column",
            alignItems: "start",
            borderRadius: "4px",
            backgroundColor: `${colors.accordion_details_bg}`,
            width: "100%",
          }}
        >
          {isSql ? (
            <>
              <SyntaxHighlighter
                language="sql"
                customStyle={{
                  fontSize: "11px",
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  backgroundColor: "transparent",
                  margin: "0",
                  padding: "0",
                }}
              >
                {sqlCommand}
              </SyntaxHighlighter>{" "}
            </>
          ) : (
            <Typography
              variant="body2"
              style={{
                whiteSpace: "pre-wrap",
                fontSize: "12px",
                width: "100%",
              }}
            >
              <pre>{sqlCommand}</pre>
            </Typography>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default SqlCommandDisplay;
